(function(){
    'use strict';

    angular
        .module('elogbooks.admin.settings')
        .controller('AdminFileEditSettingsController', AdminFileEditSettingsController);

    function AdminFileEditSettingsController(
        $controller,
        $state,
        messenger,
        moment,
        lodash,
        apiClient,
        settingsCollection,
        elbSettings,
        module,
        fileTypeService
    ) {
        const vm = this;
        const base = $controller('AdminEditSettingsController', {
            $state: $state,
            messenger: messenger,
            moment: moment,
            lodash: lodash,
            apiClient: apiClient,
            settingsCollection: settingsCollection,
            settingsFields: [
                'file_restrict',
                'file_allowed_types',
                'file_expiry_notification_time'
            ],
            elbSettings: elbSettings,
            module: module,
            fileTypeService: fileTypeService,
            validateTabSettings: null,
            buildTabSettingFormTypes: () => ({
                'file_restrict': { type: 'checkbox', notRequired: false },
                'file_allowed_types': {
                    type: 'select-multiple',
                    options: [
                        {value: 'csv', title: 'csv'},
                        {value: 'txt', title: 'txt'},
                        {value: 'msg', title: 'msg'},
                        {value: 'html', title: 'html'},
                        {value: 'xls', title: 'xls'},
                        {value: 'doc', title: 'doc'},
                        {value: 'docx', title: 'docx'},
                        {value: 'odt', title: 'odt'},
                        {value: 'ods', title: 'ods'},
                        {value: 'ppt', title: 'ppt'},
                        {value: 'pptx', title: 'pptx'},
                        {value: 'pdf', title: 'pdf'},
                        {value: 'xlsx', title: 'xlsx'},
                        {value: 'tiff', title: 'tiff'},
                        {value: 'bmp', title: 'bmp'},
                        {value: 'gif', title: 'gif'},
                        {value: 'jpeg', title: 'jpeg'},
                        {value: 'webp', title: 'webp'},
                        {value: 'png', title: 'png'},
                        {value: 'heif/heic', title: 'heif/heic'}
                    ],
                    subLabel: 'FILE_SETTINGS_DISALLOW_SUB_LABEL'
                },
                'file_expiry_notification_time': { type: 'number', min: 1, notRequired: true, subLabel: 'FILE_EXPIRY_NOTIFICATION_TIME_SUB_LABEL', options: { invalid: false } }
            })
        });

        angular.extend(vm, base);

        const fileTypes = vm.settings?.file_allowed_types?.value ? vm.settings.file_allowed_types.value.slice() : [];

        if (fileTypes.length > 0) {
            vm.settings.file_allowed_types.value = fileTypeService.mergeHeifHeic(fileTypes);
        }
    }
})();
